import React from "react";


const AuthorBio = ({
}) => {

  const authorName="Edouard Marven"
  const authorImage="/assets/images/jhon.jpg"
  const authorDescription="Edouard is an avid hiker and life enthusiast who loves exploring Vancouver’s trails and discovering its authentic dining spots."
  const twitterLink="https://twitter.com/edouardmarven"
  const linkedInLink="https://www.linkedin.com/in/edouard-marven"

  return (
    <div className="author-bio super-modern-author-bio">
      <div className="avatar-ring">
        <img src={authorImage} alt={authorName} className="avatar-image" />
      </div>
      <div className="bio-details">
        <h3 className="bio-name">{authorName}</h3>
        <p className="bio-description">{authorDescription}</p>
        <ul className="author-social-links">
          {twitterLink && (
            <li>
              <a
                href={twitterLink}
                aria-label={`Follow ${authorName} on Twitter`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
            </li>
          )}
          {linkedInLink && (
            <li>
              <a
                href={linkedInLink}
                aria-label={`Connect with ${authorName} on LinkedIn`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default AuthorBio;